export default {
  namespaced: true,
  state: {
    language: {},
    locales: ['de', 'en']
  },
  getters: {
    slug: state => locale => {
      const slug = 'slug' + locale.toUpperCase();
      if (slug in state.language) {
        return state.language[slug];
      } else {
        return state.language.slugEN;
      }
    },
    slugs: state => {
      return state.language;
    },
    locales: state => {
      return state.locales;
    }
  },
  mutations: {
    ADD_LANGUAGE: (state, language) => {
      state.language = language;
    },
    ADD_LOCALE: (state, locale) => {
      if (!state.locales.includes(locale)) {
        state.locales.push(locale);
      }
    },
    REMOVE_LOCALE: (state, locale) => {
      const index = state.locales.indexOf(locale);
      if (index > -1) {
        state.locales.splice(index, 1);
      }
    }
  }
};
